import { StoreError } from "@/components/StoreComponents/StoreError";

import { styled } from "@mui/material";
import { useCheckoutUI } from "../../CheckoutUIProvider";

const CartContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  textAlign: "left",
  gap: "16px",
  ".terms": {
    width: "100%",
    textAlign: "left",
    fontSize: 12,
    [theme.breakpoints.down("sm")]: {
      fontSize: 10,
    },
    opacity: 0.3,
    ".tosLinks": {
      color: "unset",
      "&:visited": {},
    },
  },
}));

export const RetailerError = () => {
  const [state] = useCheckoutUI();

  const checkoutError = state.context.checkoutResponse?.errorMessage;
  if (!checkoutError) return null;

  return (
    <CartContainer>
      {checkoutError && <StoreError errorMessage={checkoutError} />}
    </CartContainer>
  );
};
